const userLanguages = [
    { value: "hu", label: "hu" },
    { value: "en", label: "en" },
    { value: "de", label: "de" },
    { value: "ru", label: "ru" },
  ];
  
  export default userLanguages;